import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { Avatar, Button, Dropdown, Menu } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { pathTo, hasRoute, getRouteFromPath } from '../../../Routes';

import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';
import useFetchSignedUrl from '../../../hooks/useFetchSignedUrl';

const CareGuidesSelector = ({
  list,
  load,
  setActive,
  setAccess,
  defaultId,
  defaultLabel,
  defaultImage,
  disabled = false,
  getSignedUrl,
  imageUrl,
  setActiveImage,
  size,
  imagePath,
  ...props
}) => {
  const [currentId, setCurrentId] = useState(defaultId);
  const [currentLabel, setCurrentLabel] = useState(defaultLabel);
  // const {width} = useWindowDimensions();

  useEffect(() => {
    setCurrentId(defaultId);
  }, [defaultId, setCurrentId]);

  useEffect(() => {
    setCurrentLabel(defaultLabel);
  }, [defaultLabel, setCurrentLabel]);

  const clickHandler = (e) => {
    const id = e.item.props.value;
    const selectedCareGuide = list.filter((x) => x.id === id)[0];
    setCurrentId(selectedCareGuide.id);
    if (selectedCareGuide.partnership) {
      setAccess({
        access_role_admin_in_care_guide:
          selectedCareGuide.partnership.access_role_admin_in_care_guide,
      });
    }

    setCurrentLabel(
      selectedCareGuide.first_name + ' ' + selectedCareGuide.last_name
    );
    setActive(id);
    const currentRoute = getRouteFromPath(props.location.pathname);
    if (
      currentRoute &&
      props.careGuideScreens.includes(currentRoute.screen) &&
      currentRoute.params.id !== id
    ) {
      if (hasRoute(currentRoute.screen, { id: id })) {
        MixpanelTracker.mixpanelTrack(
          mixpanelEventsEnum.PAGES.ACCESS_CARE_GUIDE,
          {
            careGuideName: `${selectedCareGuide.first_name} ${selectedCareGuide.last_name}`,
            partnershipName:
              selectedCareGuide?.partnership?.name ?? 'No partnership',
            careGuideId: selectedCareGuide.id,
            partnershipId:
              selectedCareGuide?.partnership?.id ?? 'No partnership',
            page: currentRoute.screen,
          }
        );
        MixpanelTracker.mixpanelTrack(mixpanelEventsEnum.PAGES.ACCESS_PAGE, {
          careGuideName: `${selectedCareGuide.first_name} ${selectedCareGuide.last_name}`,
          partnershipName:
            selectedCareGuide?.partnership?.name ?? 'No partnership',
          careGuideId: selectedCareGuide.id,
          partnershipId: selectedCareGuide?.partnership?.id ?? 'No partnership',
          page: currentRoute.screen,
        });

        props.history.push(pathTo(currentRoute.screen, { id: id }));
      }
    }
  };

  const menu = (
    <Menu onClick={clickHandler}>
      {list.map((x) => (
        <Menu.Item key={x.id} value={x.id}>
          {x.first_name + ' ' + x.last_name}
        </Menu.Item>
      ))}
    </Menu>
  );

  useFetchSignedUrl(imagePath, imageUrl, getSignedUrl, setActiveImage);

  return (
    <Translation>
      {(t) => (
        <>
          {props.total > 0 ? (
            <div className='care-guide-selector'>
              {currentId ? (
                <Link to={pathTo('CareGuideDetailScreen', { id: currentId })}>
                  <Avatar size={size} src={imageUrl} icon={<UserOutlined />} />
                </Link>
              ) : (
                <Avatar size={size} src={imageUrl} icon={<UserOutlined />} />
              )}
              {list.length > 1 ? (
                <Dropdown
                  overlay={menu}
                  disabled={disabled}
                  trigger={['click']}
                >
                  <Button onClick={null}>
                    {currentLabel} <DownOutlined />
                  </Button>
                </Dropdown>
              ) : (
                <Button onClick={null}>{currentLabel}</Button>
              )}
            </div>
          ) : null}
        </>
      )}
    </Translation>
  );
};

export default withRouter(CareGuidesSelector);
